import simplebar from 'simplebar-vue'
import './index.less'

export default simplebar
